/** Placeholder for super-admin pages that ship in later sessions. */
import { useLocation } from "react-router-dom";
import { Construction } from "lucide-react";

export default function SuperadminPlaceholder() {
  const { pathname } = useLocation();
  return (
    <div
      data-testid="superadmin-placeholder"
      style={{
        background: "var(--bg-surface, #E4E2DE)",
        border: "1px solid var(--border, rgba(12,12,11,0.09))",
        borderRadius: 16,
        padding: 32,
        textAlign: "center",
      }}
    >
      <Construction size={28} style={{ color: "var(--text-tertiary, #8A8884)", margin: "0 auto" }} />
      <h2
        style={{
          fontFamily: "Barlow Condensed, sans-serif",
          fontSize: 24,
          fontWeight: 800,
          marginTop: 8,
          color: "var(--text-primary, #0C0C0B)",
        }}
      >
        Coming up
      </h2>
      <p style={{ fontSize: 13, color: "var(--text-secondary, #4A4845)", marginTop: 4 }}>
        This screen ships in a later session.
      </p>
      <code
        style={{
          display: "inline-block",
          marginTop: 12,
          fontSize: 11,
          color: "var(--text-tertiary, #8A8884)",
          background: "var(--bg-inset, #D8D6D1)",
          padding: "4px 10px",
          borderRadius: 100,
        }}
      >
        {pathname}
      </code>
    </div>
  );
}
